import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrescriptionStatusEnum } from 'src/app/shared/enum/prescription-status.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { PrescriptionMedicineStruct } from '../../services/structs/pharmacy/prescription-medicine.struct';
import { PrescriptionSolutionStruct } from '../../services/structs/pharmacy/prescription-solution.struct';

@Component({
    selector: 'app-prescriptions-suspension-cofirm-modal',
    templateUrl: './prescriptions-suspension-cofirm-modal.component.html',
    styleUrls: ['./prescriptions-suspension-cofirm-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescriptionsSuspensionCofirmModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PrescriptionsSuspensionCofirmModalComponent>,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
  ) { }

  public prescriptionStatusEnum: typeof PrescriptionStatusEnum = PrescriptionStatusEnum;

  public isLoading: boolean = true;
  public isMedicatedSolution: boolean = false;

  public model: FormGroup;
  public medicalPrescriptionToSuspend: PrescriptionMedicineStruct;
  public medicatedSolutionPrescriptionToSuspend: PrescriptionSolutionStruct;

  ngOnInit(): void {
    if(this.data){
      this.isMedicatedSolution = this.data.isMedicatedSolution;
      if(this.isMedicatedSolution)
        this.medicatedSolutionPrescriptionToSuspend = {...this.data.prescription};
      else {
        this.medicalPrescriptionToSuspend = {...this.data.prescription};
        this.medicalPrescriptionToSuspend.prescriptionMedicine = {...this.data.prescription.prescriptionMedicine}
      }
    }

    this.model = this.formBuilder.group({
      motiveSuspended: ["", [Validators.required]]
    });

    this.isLoading = false;
  }

  close() {
    this.matDialogRef.close({
      medicalPrescriptionToSuspend: this.medicalPrescriptionToSuspend,
      medicatedSolutionPrescriptionToSuspend: this.medicatedSolutionPrescriptionToSuspend,
    });
  }

  cancel() {
    this.medicalPrescriptionToSuspend = null;
    this.medicatedSolutionPrescriptionToSuspend = null;
    this.close();
  }

  submit() {
    if(this.isLoading)
      return;
    
    this.isLoading = true;
    if (this.model.invalid) {
      this.alertService.show('Erro', "Preencha todos os campos em vermelho!", AlertType.error);
      this.isLoading = false;
      return;
    }

    if(this.isMedicatedSolution){
      this.medicatedSolutionPrescriptionToSuspend.idPrescriptionStatus = this.prescriptionStatusEnum.Suspenso;
      this.medicatedSolutionPrescriptionToSuspend.motiveSuspended = this.model.get('motiveSuspended').value;
      this.medicalPrescriptionToSuspend = null;
      this.close();
    }
    else{
      this.medicalPrescriptionToSuspend.prescriptionMedicine.idPrescriptionStatus = this.prescriptionStatusEnum.Suspenso;
      this.medicalPrescriptionToSuspend.prescriptionMedicine.motiveSuspended = this.model.get('motiveSuspended').value;
      this.medicatedSolutionPrescriptionToSuspend = null;
      this.close();
    }
  }

}
